<template>
  <div class="container py-4">
    <h3 class="fw-bold text-center mb-4">Job Details</h3>

    <div v-if="loading" class="alert alert-info text-center">
      Loading...
    </div>

    <div v-else-if="!booking" class="alert alert-danger text-center">
      Booking not found or access expired
    </div>

    <div v-else class="card shadow-sm border-0 p-4">
      <!-- READ ONLY DETAILS -->
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label fw-semibold">Booking ID</label>
          <input class="form-control" :value="bookingId" disabled />
        </div>

        <div class="col-md-6">
          <label class="form-label fw-semibold">Status</label>
          <input class="form-control" :value="normalizeStatus(booking.status) || '-'" disabled />
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold">Start Time</label>
          <input class="form-control" :value="formatToSGTime(booking.startTime) || '-'" disabled />
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold">Vessel Name</label>
          <input class="form-control" :value="booking.vesselName || '-'" disabled />
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold">Booking Type</label>
          <!-- <input class="form-control" :value="booking.bookingType || '-'" disabled /> -->
          <select v-model="booking.bookingType" class="form-select" disabled>
            <option disabled value="">Select Booking Type</option>
            <option value="arrival">Arrival</option>
            <option value="departure">Departure</option>
            <option value="transfer">Transfer</option>
            <option value="disposal">Disposal</option>
            <option value="parcel">Parcel</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold">Pax</label>
          <input class="form-control" :value="booking.pax || '-'" disabled />
        </div>

        <!-- <div class="col-md-6">
          <label class="form-label fw-semibold">Crew Name</label>
          <input class="form-control" :value="booking.crewName || '-'" disabled />
        </div> -->

        <div v-if="booking.crewMembers && booking.crewMembers.length" class="mt-4">
          <h6 class="fw-bold mb-3">Crew Members</h6>

          <div
            v-for="(crew, i) in booking.crewMembers"
            :key="i"
            class="crew-card"
            @click="openWhatsApp(crew.contact)"
          >
            <div class="crew-name">
              {{ crew.name }}
            </div>
            <div class="crew-contact">
              {{ crew.contact }}
            </div>
          </div>
        </div>


        <div class="col-md-6">
          <label class="form-label fw-semibold">From</label>
          <input class="form-control" :value="booking.startLocation || '-'" disabled />
        </div>

        <div class="col-md-6">
          <label class="form-label fw-semibold">To</label>
          <input class="form-control" :value="booking.endLocation || '-'" disabled />
        </div>
        <div class="col-md-12">
          <label class="form-label fw-semibold">Remarks</label>
          <input class="form-control" :value="booking.remarks || '-'" disabled />
        </div>
        <div v-if="booking.trips && booking.trips.length" class="mt-4">
          <h6 class="fw-bold mb-2">Additional Trips</h6>

          <div
            v-for="(trip, i) in booking.trips"
            :key="i"
            class="info-box mb-2"
          >
            {{ trip }}
          </div>
        </div>
        <div v-if="booking.flightNumbers && booking.flightNumbers.length" class="mt-4">
          <h6 class="fw-bold mb-2">Flight Information</h6>

          <div
            v-for="(flight, i) in booking.flightNumbers"
            :key="i"
            class="info-box mb-2"
          >
            <strong>{{ flight.number }}</strong>
            <!-- <span class="badge-flight ms-2">
              {{ flight.isArrival ? 'Arrival' : 'Departure' }}
            </span> -->
          </div>
        </div>
        




          <!-- <div class="text-end mb-3" v-if="role === 'admin' || role === 'driver' "> -->
          <!-- Vouchers -->
          <!-- Vouchers -->
          <div class="mb-4" v-if="role === 'admin' || role === 'driver'">

            <div class="d-flex justify-content-between align-items-center mb-2">
              <h5 class="fw-bold mb-0">Transport Vouchers</h5>

              <button
                class="btn btn-sm btn-success"
                @click="goCreateVoucher"
                :disabled="role !== 'driver'"
              >
                + Create Voucher
              </button>
            </div>

            <div v-if="booking.vouchers && booking.vouchers.length">

              <div
                v-for="(voucherId, i) in booking.vouchers"
                :key="voucherId"
                class="d-flex justify-content-between align-items-center p-3 mb-2 bg-light rounded border"
              >
                <div>
                  <strong>Voucher {{ i + 1 }}</strong>
                  <div class="text-muted small">{{ voucherId }}</div>
                </div>

                <div class="d-flex gap-3">
                  <button
                    class="btn btn-sm btn-outline-primary"
                    @click="viewVoucher(voucherId)"
                  >
                    View
                  </button>

              
                </div>
              </div>

            </div>

            <div v-else class="text-muted small">
              No vouchers yet
            </div>

          </div>


      </div>
      


      <hr class="my-4" />

      <!-- IMAGE PROOF -->
      <div v-if="role=='driver'">
        <h5 class="fw-bold mb-3">Upload Image Proof</h5>

        <!-- <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="onboard"
            v-model="isOnboard"
          />
          <label class="form-check-label" for="onboard">
            Crew Onboard (untick = Completed)
          </label>
        </div> -->

        <!-- CAMERA ONLY -->
        <input
          type="file"
          class="form-control"
          accept="image/*"
          capture="environment"
          @change="handleCameraCapture"
        />

        <div v-if="previewUrl" class="mt-3">
          <img
            :src="previewUrl"
            class="img-fluid rounded border"
            alt="Preview"
          />
        </div>

        <button
          class="btn btn-primary w-100 mt-3"
          :disabled="uploading || !capturedFile"
          @click="uploadImageProof"
        >
          <span v-if="!uploading">Upload Image</span>
          <span v-else class="spinner-border spinner-border-sm"></span>
        </button>
        <button
          v-if="!['On Board', 'Completed', 'on_board'].includes(normalizeStatus(booking.status))"
          class="btn btn-warning w-100 mt-2"
          :disabled="moving || !hasOnboardPhoto()"
          @click="moveJob(true)"
        >
          <span v-if="!moving">Move Job → On Board</span>
          <span v-else class="spinner-border spinner-border-sm"></span>
        </button>

          <button
            v-if="['On Board','on_board'].includes(normalizeStatus(booking.status))"
            class="btn btn-success w-100 mt-2"
            :disabled="moving || !hasCompletedPhoto()"
            @click="moveJob(false)"
          >
            <span v-if="!moving">Move Job → Completed</span>
            <span v-else class="spinner-border spinner-border-sm"></span>
          </button>
      </div>

      <!-- EXISTING IMAGE PROOFS -->
      <div
        class="mt-4"
        v-if="booking.images_proof && booking.images_proof.length"
      >
        <h6 class="fw-bold mb-3">Uploaded Proofs</h6>

        <div class="row g-3">
          <div
            v-for="(img, i) in booking.images_proof"
            :key="i"
            class="col-md-4"
          >
            <div class="proof-card">
              <img
                v-if="img.previewUrl"
                :src="img.previewUrl"
                class="proof-img"
              />

              <div class="proof-info">
                {{ img.uploadedAt }}  
                <br />
                <strong>
                  {{ img.isOnboard ? 'Onboard' : 'Completed' }}
                </strong>
              </div>
              <button
                v-if="role != 'admin'"
                class="btn btn-sm btn-danger mt-2 w-100"
                @click="openDeleteImageModal(img)"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <ConfirmDeleteModal ref="confirmDelete" />
  </div>
</template>

<script>
import axios from 'axios'
import { useToast } from 'vue-toastification'
import ConfirmDeleteModal from '@/components/ConfirmDeleteModal.vue'

export default {
  name: 'JobStartEndPage',

  components: { ConfirmDeleteModal },

  data() {
    return {
      loading: true,
      booking: null,
      bookingId: null,
      role: null,

      capturedFile: null,
      previewUrl: null,
      uploading: false,
      moving:false
    }
  },

  setup() {
    const toast = useToast()
    return { toast }
  },

  methods: {
    goCreateVoucher() {
      const token = localStorage.getItem('accessToken')
      this.$router.push(`/SignDoc/${this.bookingId}/${token}`)
    },
    formatToSGTime(dateStr) {
      if (!dateStr) return "-"

      const date = new Date(dateStr)

      return new Intl.DateTimeFormat("en-SG", {
        timeZone: "Asia/Singapore",
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      }).format(date)
    },
    normalizeStatus(status) {
      if (!status) return 'new'

      const s = status.toLowerCase().trim()

      if (s === 'new') return 'new'
      if (s === 'on board' || s === 'on_board') return 'On Board'
      if (s === 'completed') return 'Completed'
      if (s === 'Cancelled') return 'Cancelled'

      return 'new'
    },
    handleCameraCapture(e) {
      const file = e.target.files[0]
      if (!file) return

      this.capturedFile = file
      this.previewUrl = URL.createObjectURL(file)
    },
    async viewVoucher(voucherId) {
      try {
        const res = await axios.get(
          `${this.$apiURL}/api/vouchers/${voucherId}/signed-view`,
          {
            headers: {
              Authorization: localStorage.getItem('accessToken')
            }
          }
        )

        if (res.data?.ok && res.data.url) {
          // window.open(res.data.url, "_blank")
          window.location.href = res.data.url
        } else {
          this.toast.error("Unable to load voucher")
        }

      } catch (err) {
        console.error(err)
        this.toast.error("Failed to load voucher")
      }
    },

    async uploadImageProof() {
      if (!this.capturedFile) return

      this.uploading = true
      try {
        const fd = new FormData()
        fd.append('file', this.capturedFile)
        let isOnboard = true

        // logic based on current status
        if (this.booking.status === 'on_board') {
          isOnboard = false
        }

        fd.append('isOnboard', isOnboard)


        await axios.post(
          `${this.$apiURL}/api/bookings/${this.bookingId}/image-proof`,
          fd,
          {
            headers: {
              Authorization: localStorage.getItem('accessToken')
            }
          }
        )

        this.toast.success('Image uploaded')
        this.capturedFile = null
        this.previewUrl = null
        await this.fetchBooking()
      } catch (e) {
        this.toast.error('Upload failed')
      } finally {
        this.uploading = false
      }
    },
    openWhatsApp(contact) {
      if (!contact) return

      // remove spaces and dashes
      let number = contact.replace(/[\s-]/g, "")

      // remove leading +
      if (number.startsWith("+")) {
        number = number.substring(1)
      }

      // if local SG number (8 digits), auto add 65
      if (number.length === 8) {
        number = "65" + number
      }

      const url = `https://wa.me/${number}`

      window.open(url, "_blank")
    },
    async moveJob(isOnboard) {

      if (this.moving) return

      this.moving = true

      try {

        await axios.post(
          `${this.$apiURL}/api/bookings/${this.bookingId}/move-job`,
          { isOnboard: isOnboard },
          {
            headers: {
              Authorization: localStorage.getItem('accessToken')
            }
          }
        )

        this.toast.success("Job status updated")

        if (isOnboard) {
          this.booking.status = "on_board"
        } else {
          this.booking.status = "completed"
        }

      } catch (err) {
        console.error(err)
        this.toast.error("Failed to move job")
      } finally {
        this.moving = false
      }

    },
    async fetchBooking() {
      const res = await axios.get(
        `${this.$apiURL}/api/bookings/${this.bookingId}`,
        {
          headers: {
            Authorization: localStorage.getItem('accessToken')
          }
        }
      )

      this.booking = res.data
    },
    hasOnboardPhoto() {
      if (!this.booking.images_proof) return false

      return this.booking.images_proof.some(img => img.isOnboard === true)
    },

    hasCompletedPhoto() {
      if (!this.booking.images_proof) return false

      return this.booking.images_proof.some(img => img.isOnboard === false)
    },
    openDeleteImageModal(img) {
      this.$refs.confirmDelete.open({
        title: 'Delete Image',
        message: `Are you sure you want to delete this ${img.isOnboard ? 'onboard' : 'completed'} proof image?`,
        onConfirm: () => this.deleteImage(img)
      })
    },
    async deleteImage(img) {

      try {

        await axios.delete(
          `${this.$apiURL}/api/bookings/${this.bookingId}/image-proof`,
          {
            headers: {
              Authorization: localStorage.getItem('accessToken')
            },
            data: {
              filePath: img.filePath
            }
          }
        )

        this.toast.success("Image deleted")

        await this.fetchBooking()

      } catch (err) {

        console.error(err)
        this.toast.error("Failed to delete image")

      }

    }
  },

  async mounted() {
    const token = this.$route.params.token
    if (!token) {
      this.toast.error('Missing token')
      return
    }

    try {
      // 1️⃣ verify token
      const verifyRes = await axios.get(
        `${this.$apiURL}/api/token/verify`,
        { params: { token } }
      )

      this.role = verifyRes.data.role
      this.bookingId = verifyRes.data.bookingId
      localStorage.setItem('accessToken', token)

      // 2️⃣ get booking
      const bookingRes = await axios.get(
        `${this.$apiURL}/api/bookings/${this.bookingId}`,
        {
          headers: { Authorization: token }
        }
      )

      this.booking = bookingRes.data
    } catch (err) {
      this.toast.error('Access expired or invalid')
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
img {
  max-height: 500px;
  object-fit: contain;
}
.proof-card {
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  text-align: center;
}

.proof-img {
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.proof-info {
  font-size: 12px;
  margin-top: 6px;
  color: #666;
}

.crew-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
}

.crew-name {
  font-weight: 600;
  font-size: 14px;
}

.crew-contact {
  font-size: 13px;
  color: #6c757d;
}


</style>
